
import { FirstSectionError } from './components/firstSection';


export  const ErrorPage = () => {
    return (
        <div>
            <FirstSectionError/>
        </div>
    );
};
